import React from 'react';
import { render } from 'react-dom';
import { createInertiaApp } from '@inertiajs/react';
import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn: process.env.MIX_SENTRY_LARAVEL_DSN
});

createInertiaApp({
  resolve: name => import(`./Pages/${name}`).then(module => module.default),
  setup({ el, App, props }) {
    render(<App {...props} />, el);
  },
  progress: {
    color: '#ED8936',
    showSpinner: true
  }
});
